import { IJamaItem } from "../Interfaces/DataInterface"
import { TReactSelectOption } from "../Interfaces/ExternalComponentsInterfaces"

const parseDataForReactSelect = (data: IJamaItem[]) => {
	const arr: TReactSelectOption[] = []
	data.map(({ id, name }: IJamaItem) => arr.push({ value: id, label: name }))

	return arr
}

export default parseDataForReactSelect
